import React, { Component, createRef } from 'react';
import { auth } from './firebase';
class Login extends Component {

    constructor(props) {
        super(props);
    
        this.email = createRef();
        this.password = createRef();
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

      handleSuccess() {
        //this.resetForm();
        console.log("SIgnIn"); 
        this.props.history.push("")
      }
    
      handleErrors(reason) {
       //?
       console.log("error");
      }
    
      handleSubmit(event) {
        event.preventDefault();
        const {
          email,
          password,
        } = this;

       auth.userSession(
          "signIn",
          email.current.value,
          password.current.value
        ).then(this.handleSuccess).catch(this.handleErrors);
      }

      resetForm() {
      }
    
  render() {
    return (
      <div class="container py-5">
      <div class="row">
          <div class="col-md-12">
              <h2 class="text-center text-white mb-4">Bootstrap 4 Login Form</h2>
              <div class="row">
                  <div class="col-md-6 mx-auto">
                      <div class="card rounded-0">
                          <div class="card-header">
                              <h3 class="mb-0">Login</h3>
                          </div>
                          <div class="card-body">
                              <form class="form" role="form" autocomplete="off" id="formLogin" novalidate="" onSubmit={this.handleSubmit}> 
                                  <div class="form-group">
                                      <label>Username</label>
                                      <input type="text" 
                                      class="form-control form-control-lg rounded-0" 
                                      name="name"
                                      ref={this.email} />
                                  </div>
                                  <div class="form-group">
                                      <label>Password</label>
                                      <input type="password" 
                                      class="form-control form-control-lg rounded-0" 
                                      name="password" 
                                      ref={this.password}
                                      /*autocomplete="new-password"*//>
                                  </div>
                                  <button type="submit" class="btn btn-success btn-lg float-right">Login</button>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
    );
  }
}

export default Login;
